/* ==========================================================================
   PanelVehicleRxjs > Client > vehicle
   ========================================================================== */

function isValidVehicleDimensions(instance) {
    const { vehicleDimensions = [] } = instance;

    /* Don't have nothing to validate */
    if (vehicleDimensions.length < 2) return true;

    const { value: vehicleLength, error: vehicleLengthError } = vehicleDimensions[0].store.select('input');
    const { value: vehicleHeight, error: vehicleHeightError } = vehicleDimensions[1].store.select('input');

    const lenghtIsValid = Number.isInteger(Number(vehicleLength)) && Number(vehicleLength) > 0;
    const heigthIsValid = Number.isInteger(Number(vehicleHeight)) && Number(vehicleHeight) > 0;

    /* Length error */
    if (!lenghtIsValid) vehicleDimensions[0].actions.setError();
    else if (vehicleLengthError) vehicleDimensions[0].actions.resetStatus();

    /* height error */
    if (!heigthIsValid) vehicleDimensions[1].actions.setError();
    else if (vehicleHeightError) vehicleDimensions[1].actions.resetStatus();

    if (!lenghtIsValid || !heigthIsValid) return false;

    return true;
}

function isValidTrailerDimensions(instance) {
    const { trailerDimensions = [] } = instance;
    const { trailer } = instance.store.select('data');

    /* Don't have nothing to validate */
    if (!trailer) return true;

    const { value: length, error: lengthError } = trailerDimensions[0].store.select('input');
    const { value: height, error: heightError } = trailerDimensions[1].store.select('input');

    const lenghtIsValid = Number.isInteger(Number(length)) && Number(length) > 0;
    const heigthIsValid = Number.isInteger(Number(height)) && Number(height) > 0;

    /* Length error */
    if (!lenghtIsValid) trailerDimensions[0].actions.setError();
    else if (lengthError) trailerDimensions[0].actions.resetStatus();

    /* height error */
    if (!heigthIsValid) trailerDimensions[1].actions.setError();
    else if (heightError) trailerDimensions[1].actions.resetStatus();

    if (!lenghtIsValid || !heigthIsValid) return false;

    return true;
}

function validate(instance) {
    const { config = {}, store = {} } = instance;
    const { literals = {} } = config;
    const { errorVehicleDimensions = '', errorTrailerDimensions = '' } = literals;

    const { hasError } = store.select('data');

    if (!isValidTrailerDimensions(instance)) {
        instance.actions.setError(errorVehicleDimensions);
    } else if (!isValidVehicleDimensions(instance)) {
        instance.actions.setError(errorTrailerDimensions);
    } else if (hasError) {
        instance.actions.removeError();
    }

    return instance;
}

module.exports = {
    validate
};
